import { EmptyState, LoadingState, VDocxViewer } from '@vrzl/ui';
import { FileX } from 'lucide-react';

import { ApiError } from '@/domains/general/api/client';

import { useDocumentBlob } from '../api/queries';

type Props = {
  eventId: string;
  docId: string;
  selectedEvidence: { pages?: number[]; sentence?: string; plainSentence?: string } | null;
};

/**
 * Spiegelbeeld van DocumentPdfPanel: haalt de (gecachte) blob op en voedt
 * VDocxViewer. Evidence-selectie uit het results-panel wordt doorgegeven als
 * highlightTarget; de viewer lokaliseert, highlight en scrolt zelf.
 */
export function DocumentDocxPanel({ eventId, docId, selectedEvidence }: Props) {
  const { data: blob, isPending, error } = useDocumentBlob(eventId, docId);

  const isNotFound = error instanceof ApiError && error.status === 404;

  if (isPending) {
    return <LoadingState message="Document laden..." />;
  }

  if (isNotFound) {
    return (
      <EmptyState
        icon={FileX}
        title="Document niet gevonden"
        description="Dit document is niet beschikbaar of bestaat niet."
      />
    );
  }

  if (error) {
    return (
      <EmptyState
        icon={FileX}
        title="Kon Word-document niet laden"
        description="Probeer het later opnieuw."
      />
    );
  }

  if (!blob) return null;

  return (
    <VDocxViewer
      source={blob}
      highlightTarget={
        selectedEvidence?.sentence
          ? { sentence: selectedEvidence.sentence, plainSentence: selectedEvidence.plainSentence }
          : null
      }
    />
  );
}
